import { servicios } from '../properties';
import { callService } from '../tools';
//import appTimer from '../app-timer';
/*
export const verificarEmail = (sParam) => {
    return fetch(servicios.verificarEmail, {
        method: 'post',
        body: JSON.stringify({
            usuario: sParam
        })
    });
}
export const enviarCorreoRecuperacion = (sParam) => {
    return fetch(servicios.enviarCorreoRecuperacion, {
        method: 'post',
        body: JSON.stringify({
            usuario: sParam
        })
    });
}*/

export const verificarEmail = (correo) => {
    console.log("VM: "+correo);
    return dispatch => {
        dispatch({ "type": "OLVIDE_SET_FLAG_ERROR", 
                     "flag" : false
                  });
        
        let llamadaSeguro = new callService({
			service: 'olvideContrasena.consultarUsuario',
			"secure": true,
			data: { correo: correo}
		}).execute().then(body=>{
		    if(body.hasOwnProperty('error')){
		          dispatch({ "type": "LOADER_HIDE"});
                  dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                      "titulo": "Error", 
                      "mensaje" : "Tuvimos un error" 
                  });
              }
              else {
                 console.log(body);
                 if(body.uid == 0)
                 {
                     dispatch({ "type": "LOADER_HIDE"});
                     dispatch({ "type": "OLVIDE_SET_PASO", "paso": "bloqueado"});
                 }
                 else{
                     let url = body.uid + "/" + body.time + "/" + body.estatus;
                     //dispatch({ "type": "RECUPERAR_SET_UID", "uid": body.uid });
                     dispatch({ "type": "LOGIN_RESET_PASO" });
                     dispatch({ "type": "OLVIDE_SET_URL", "url": body.uid + "/" + body.time + "/" + body.estatus});
                     dispatch({ "type": "OLVIDE_SET_CORREO", "correo": correo});
                     
                     let llamadaSeguro = new callService({
            			service: 'olvideContrasena.enviarCorreo',
            			"secure": true,
            			data: { correo: correo, url: url}
            		}).execute().then(body=>{
            		    dispatch({ "type": "LOADER_HIDE"});
            		    if(body.hasOwnProperty('error')){
                              dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                                  "titulo": "Error", 
                                  "mensaje" : "Tuvimos un error" 
                              });
                          }
                          else {
                             console.log(body);
                             if(body.correlationId != "" )
                             {
                		         dispatch({ "type": "OLVIDE_PASO_SIGUIENTE" });
                             }
                             else {
                                 console.log("hubo un error");
                             }
                             
                          }
            		}).catch(error => {
            		    dispatch({ "type": "LOADER_HIDE"});
            		    console.log(error);
            		    
        		        dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                              "titulo": "Error", 
                              "mensaje" : "Hubo un error al mandar el correo. Favor de intentar más tarde." 
                          });
            		}); 
                 }
              }
		}).catch(error => {
		    dispatch({ "type": "LOADER_HIDE"});
		    console.log(error);
		    if(error.hasOwnProperty('message') && error.message.codigoError == "eCl00088"){
		        dispatch({ "type": "OLVIDE_SET_MENSAJE_ERROR", 
                      "mensaje" : "Lo sentimos, el correo electrónico proporcionado no está registrado." 
                  });
                dispatch({ "type": "OLVIDE_SET_FLAG_ERROR", 
                      "flag" : true
                  }); 
		    }
		    else if(error.hasOwnProperty('message') && error.message.codigoError == "eCl00006"){
		        dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                      "titulo": "Error", 
                      "mensaje" : "Hubo un error al hacer la migración. Favor de comunicarse al Call Center." 
                  });
		    }
		    else if(error.hasOwnProperty('body') && error.body.codigoError == "ERROR_AUT003")
		    {
		        dispatch({ "type": "OLVIDE_SET_MENSAJE_ERROR", 
                      "mensaje" : "Lo sentimos, el correo electrónico proporcionado no está registrado."
                  });
                dispatch({ "type": "OLVIDE_SET_FLAG_ERROR", 
                      "flag" : true
                  }); 
		    }
		    else {
		        dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", 
                      "titulo": "Error", 
                      "mensaje" : "Hubo un error al generar la Url. Favor de intentar más tarde." 
                  });
		    }
		    
            
		});
    }
}


// WEBPACK FOOTER //
// ./src/olvide/services.act.js